// extracted by mini-css-extract-plugin
export default {"body":"PreferencesPanel_body__UyBaR"};